import React from 'react';
import PropTypes from 'prop-types';

import { staticURL } from 'core/url';
import { ExternalLink } from 'core/routing';

import { ChinaLinkStyled } from 'apps/components/footer/footer.styled';

const ChinaMPSBRecord = props =>
  !props.chinaMode ? null : (
    <ChinaLinkStyled
      mobile={props.mobile}
      main={props.main}
      hiddenMediumToLarge={props.hiddenMediumToLarge}
    >
      <img
        src={staticURL('assets/china/备案图标.png')}
        alt='China governament icon MPSB record code'
      />
      <ExternalLink to='http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51010402001116'>
        {'川公网安备 51010402001116号'}
      </ExternalLink>
    </ChinaLinkStyled>
  );

ChinaMPSBRecord.propTypes = {
  chinaMode: PropTypes.bool,
  mobile: PropTypes.bool,
  main: PropTypes.bool,
  hiddenMediumToLarge: PropTypes.bool,
};

export default ChinaMPSBRecord;
